/**
 * KeyboardScrollFix
 * Mobil PWA ve WebView'larda sanal klavye açılıp kapandığında
 * Header'ın yukarı kaçmasını ve ekranın taşmasını (offset kayması) engeller.
 */

export const initKeyboardScrollFix = () => {
  if (typeof window === 'undefined') return () => {};

  let isKeyboardOpen = false;
  let initialVisualViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

  const handleFocusIn = (e) => {
    const target = e.target;
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) {
      isKeyboardOpen = true;
    }
  };

  // 🛡️ KLAVYE KAPANMA RESETI:
  // Sadece visualViewport scroll offseti bozulduğunda ve pencere dışına taşma olduğunda düzeltilir.
  // Kullanıcının sepet veya form içindeki sayfa kaydırma konumunu sıfırlamaz (top: 0 fırlatması engellendi).
  const handleFocusOut = (e) => {
    const target = e.target;
    if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)) {
      isKeyboardOpen = false;
      // Dokümanın doğal scroll pozisyonunu sıfırlamıyoruz. Sadece mobil tarayıcıların visualViewport scroll'u takılı kalmışsa toparlıyoruz.
      if (window.visualViewport && window.visualViewport.offsetTop > 0) {
        window.scrollTo({
          top: window.scrollY,
          left: 0,
          behavior: 'instant'
        });
      }
    }
  };

  // VisualViewport API desteği (modern mobil tarayıcılar için)
  const handleViewportResize = () => {
    if (!window.visualViewport) return;
    const currentHeight = window.visualViewport.height;

    // Viewport tekrar büyüdüyse (klavye kapandıysa)
    if (currentHeight >= initialVisualViewportHeight - 50) {
      isKeyboardOpen = false;
    }
  };

  document.addEventListener('focusin', handleFocusIn, { passive: true });
  document.addEventListener('focusout', handleFocusOut, { passive: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', handleViewportResize);
  }

  console.log('📱 KeyboardScrollFix: Virtual keyboard auto-restore shield initialized.');

  return () => {
    document.removeEventListener('focusin', handleFocusIn);
    document.removeEventListener('focusout', handleFocusOut);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', handleViewportResize);
    }
  };
};

export default initKeyboardScrollFix;
